import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { DirectoryRecord } from "@/shared/domain/files";

interface RenameDirectoryProps {
  datasetId: string;
  currentPath: string;
  newName: string;
}

export function useRenameDirectory() {
  const { files: fileService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<DirectoryRecord, Error, RenameDirectoryProps>({
    mutationFn: ({ datasetId, currentPath, newName }) => {
      return fileService.renameDirectory(datasetId, currentPath, newName);
    },
    onSuccess: (directory) => {
      queryClient.setQueryData(["directoryRecord", directory.name], directory);
      return queryClient.invalidateQueries({ queryKey: ["directoryContents"] });
    },
  });
}
